/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  TaxBase,
  TaxBaseOptional,
  TaxBaseMetaI,
  TaxBaseTrackedI,
} from "./tax-base";
import { TaxBaseTracked, TaxBaseMeta } from "./tax-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  TaxRef,
  TaxRefOptional,
  TaxRefMetaI,
  TaxRefTrackedI,
} from "./tax-ref";
import { TaxRefTracked, TaxRefMeta } from "./tax-ref";

/**
 *
 * @export
 * @interface TaxFull
 */
export interface TaxFullOptional extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof TaxFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TaxFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof TaxFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  taxName?: string;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  taxCode?: string;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  taxRate?: string;
  /**
   *
   * @type {number}
   * @memberof TaxFull
   */
  taxAmountFixedCents?: number;
  /**
   *
   * @type {number}
   * @memberof TaxFull
   */
  taxMinValueCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof TaxFull
   */
  taxBeforeDiscount?: boolean;
}

export interface TaxFull extends TaxFullOptional, Deletable, TaxBase, TaxRef {
  /**
   *
   * @type {boolean}
   * @memberof TaxFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TaxFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof TaxFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  tempID?: string;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  taxName: string;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  taxCode?: string;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  taxRate?: string;
  /**
   *
   * @type {number}
   * @memberof TaxFull
   */
  taxAmountFixedCents?: number;
  /**
   *
   * @type {number}
   * @memberof TaxFull
   */
  taxMinValueCents?: number;
  /**
   *
   * @type {boolean}
   * @memberof TaxFull
   */
  taxBeforeDiscount?: boolean;
}

export interface TaxFullTrackedI extends DeletableOptional {
  /**
   *
   * @type {boolean}
   * @memberof TaxFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TaxFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof TaxFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  tempID?: string;
  tempIDIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  taxName?: string;
  taxNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  taxCode?: string;
  taxCodeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof TaxFull
   */
  taxRate?: string;
  taxRateIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof TaxFull
   */
  taxAmountFixedCents?: number;
  taxAmountFixedCentsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof TaxFull
   */
  taxMinValueCents?: number;
  taxMinValueCentsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TaxFull
   */
  taxBeforeDiscount?: boolean;
  taxBeforeDiscountIsSet: boolean;
}

transformDatesMap.set("TaxFull", function (model: TaxFull) {});

export type TaxFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  tempID: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  taxName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  taxCode: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  taxRate: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  taxAmountFixedCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  taxMinValueCents: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  taxBeforeDiscount: PropertyMeta<MetaTypeBase<boolean>>;
}>;

export var TaxFullMeta: TaxFullMetaI = {} as TaxFullMetaI;
TaxFullMeta = typeMeta("TaxFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  tempID: propertyMeta("tempID", false, false, false, MetaTypesBase.string),
  taxName: propertyMeta("taxName", false, true, false, MetaTypesBase.string),
  taxCode: propertyMeta("taxCode", false, false, false, MetaTypesBase.string),
  taxRate: propertyMeta("taxRate", false, false, false, MetaTypesBase.string),
  taxAmountFixedCents: propertyMeta(
    "taxAmountFixedCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  taxMinValueCents: propertyMeta(
    "taxMinValueCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  taxBeforeDiscount: propertyMeta(
    "taxBeforeDiscount",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
});

const metaI = TaxFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([TaxRefMeta]);
  metaI.assignId.inheritedFrom = TaxRefMeta.assignId;
  metaI.tempID.inheritedFrom = TaxRefMeta.tempID;
  metaI.interfaces = metaI.interfaces.concat([TaxBaseMeta]);
  metaI.taxName.inheritedFrom = TaxBaseMeta.taxName;
  metaI.taxCode.inheritedFrom = TaxBaseMeta.taxCode;
  metaI.taxRate.inheritedFrom = TaxBaseMeta.taxRate;
  metaI.taxAmountFixedCents.inheritedFrom = TaxBaseMeta.taxAmountFixedCents;
  metaI.taxMinValueCents.inheritedFrom = TaxBaseMeta.taxMinValueCents;
  metaI.taxBeforeDiscount.inheritedFrom = TaxBaseMeta.taxBeforeDiscount;
});

export class TaxFullTracked
  extends DeletableTracked
  implements TaxFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  tempID__I?: string = undefined;
  tempIDIsSet: boolean = false;
  set tempID(v: undefined | string) {
    if (v !== undefined) {
      this.tempID__I = v;
      this.tempIDIsSet = true;
    } else {
      this.tempID__I = v || undefined;
      this.tempIDIsSet = false;
    }
    this.changeTracker = true;
  }
  get tempID() {
    return this.tempID__I;
  }
  taxName__I?: string = undefined;
  taxNameIsSet: boolean = false;
  set taxName(v: undefined | string) {
    if (v !== undefined) {
      this.taxName__I = v;
      this.taxNameIsSet = true;
    } else {
      this.taxName__I = v || undefined;
      this.taxNameIsSet = true;
    }
    this.changeTracker = true;
  }
  get taxName() {
    return this.taxName__I;
  }
  taxCode__I?: string = undefined;
  taxCodeIsSet: boolean = false;
  set taxCode(v: undefined | string) {
    if (v !== undefined) {
      this.taxCode__I = v;
      this.taxCodeIsSet = true;
    } else {
      this.taxCode__I = v || undefined;
      this.taxCodeIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxCode() {
    return this.taxCode__I;
  }
  taxRate__I?: string = undefined;
  taxRateIsSet: boolean = false;
  set taxRate(v: undefined | string) {
    if (v !== undefined) {
      this.taxRate__I = v;
      this.taxRateIsSet = true;
    } else {
      this.taxRate__I = v || undefined;
      this.taxRateIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxRate() {
    return this.taxRate__I;
  }
  taxAmountFixedCents__I?: number = undefined;
  taxAmountFixedCentsIsSet: boolean = false;
  set taxAmountFixedCents(v: undefined | number) {
    if (v !== undefined) {
      this.taxAmountFixedCents__I = v;
      this.taxAmountFixedCentsIsSet = true;
    } else {
      this.taxAmountFixedCents__I = v || undefined;
      this.taxAmountFixedCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxAmountFixedCents() {
    return this.taxAmountFixedCents__I;
  }
  taxMinValueCents__I?: number = undefined;
  taxMinValueCentsIsSet: boolean = false;
  set taxMinValueCents(v: undefined | number) {
    if (v !== undefined) {
      this.taxMinValueCents__I = v;
      this.taxMinValueCentsIsSet = true;
    } else {
      this.taxMinValueCents__I = v || undefined;
      this.taxMinValueCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxMinValueCents() {
    return this.taxMinValueCents__I;
  }
  taxBeforeDiscount__I?: boolean = undefined;
  taxBeforeDiscountIsSet: boolean = false;
  set taxBeforeDiscount(v: undefined | boolean) {
    if (v !== undefined) {
      this.taxBeforeDiscount__I = v;
      this.taxBeforeDiscountIsSet = true;
    } else {
      this.taxBeforeDiscount__I = v || undefined;
      this.taxBeforeDiscountIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxBeforeDiscount() {
    return this.taxBeforeDiscount__I;
  }
  constructor(config?: TaxFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;
    if (this.tempIDIsSet == true && other?.tempIDIsSet == true)
      return this.tempID == other.tempID;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
  }
  assignFrom(
    config: TaxFullOptional,
    options?: AssignOptions,
  ): TaxFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.tempID && this.tempIDApplyFilter(optionsRequired.filter)) {
      this.tempID = config.tempID;
      if (optionsRequired.unassign) this.tempIDIsSet = false;
      else this.tempIDIsSet = true;
    }
    if (config.taxName && this.taxNameApplyFilter(optionsRequired.filter)) {
      this.taxName = config.taxName;
      if (optionsRequired.unassign) this.taxNameIsSet = false;
      else this.taxNameIsSet = true;
    }
    if (config.taxCode && this.taxCodeApplyFilter(optionsRequired.filter)) {
      this.taxCode = config.taxCode;
      if (optionsRequired.unassign) this.taxCodeIsSet = false;
      else this.taxCodeIsSet = true;
    }
    if (config.taxRate && this.taxRateApplyFilter(optionsRequired.filter)) {
      this.taxRate = config.taxRate;
      if (optionsRequired.unassign) this.taxRateIsSet = false;
      else this.taxRateIsSet = true;
    }
    if (
      config.taxAmountFixedCents &&
      this.taxAmountFixedCentsApplyFilter(optionsRequired.filter)
    ) {
      this.taxAmountFixedCents = config.taxAmountFixedCents;
      if (optionsRequired.unassign) this.taxAmountFixedCentsIsSet = false;
      else this.taxAmountFixedCentsIsSet = true;
    }
    if (
      config.taxMinValueCents &&
      this.taxMinValueCentsApplyFilter(optionsRequired.filter)
    ) {
      this.taxMinValueCents = config.taxMinValueCents;
      if (optionsRequired.unassign) this.taxMinValueCentsIsSet = false;
      else this.taxMinValueCentsIsSet = true;
    }
    if (
      config.taxBeforeDiscount &&
      this.taxBeforeDiscountApplyFilter(optionsRequired.filter)
    ) {
      this.taxBeforeDiscount = config.taxBeforeDiscount;
      if (optionsRequired.unassign) this.taxBeforeDiscountIsSet = false;
      else this.taxBeforeDiscountIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): TaxFullTrackedI {
    const cloned = {} as TaxFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.tempIDIsSetDeep() &&
      this.tempIDApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIDIsSet = true;
      cloned.tempID = this.tempID;
    } else {
      //cloned.tempIDIsSet = false
    }
    if (
      this.taxNameIsSetDeep() &&
      this.taxNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxNameIsSet = true;
      cloned.taxName = this.taxName;
    } else {
      //cloned.taxNameIsSet = false
    }
    if (
      this.taxCodeIsSetDeep() &&
      this.taxCodeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxCodeIsSet = true;
      cloned.taxCode = this.taxCode;
    } else {
      //cloned.taxCodeIsSet = false
    }
    if (
      this.taxRateIsSetDeep() &&
      this.taxRateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxRateIsSet = true;
      cloned.taxRate = this.taxRate;
    } else {
      //cloned.taxRateIsSet = false
    }
    if (
      this.taxAmountFixedCentsIsSetDeep() &&
      this.taxAmountFixedCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxAmountFixedCentsIsSet = true;
      cloned.taxAmountFixedCents = this.taxAmountFixedCents;
    } else {
      //cloned.taxAmountFixedCentsIsSet = false
    }
    if (
      this.taxMinValueCentsIsSetDeep() &&
      this.taxMinValueCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxMinValueCentsIsSet = true;
      cloned.taxMinValueCents = this.taxMinValueCents;
    } else {
      //cloned.taxMinValueCentsIsSet = false
    }
    if (
      this.taxBeforeDiscountIsSetDeep() &&
      this.taxBeforeDiscountApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxBeforeDiscountIsSet = true;
      cloned.taxBeforeDiscount = this.taxBeforeDiscount;
    } else {
      //cloned.taxBeforeDiscountIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): TaxFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.tempIDApplyFilter(filter)) this.tempIDIsSet = false;

    if (!this.taxNameApplyFilter(filter)) this.taxNameIsSet = false;

    if (!this.taxCodeApplyFilter(filter)) this.taxCodeIsSet = false;

    if (!this.taxRateApplyFilter(filter)) this.taxRateIsSet = false;

    if (!this.taxAmountFixedCentsApplyFilter(filter))
      this.taxAmountFixedCentsIsSet = false;

    if (!this.taxMinValueCentsApplyFilter(filter))
      this.taxMinValueCentsIsSet = false;

    if (!this.taxBeforeDiscountApplyFilter(filter))
      this.taxBeforeDiscountIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxFullMeta.isDeleted, TaxFullMeta, this.isDeleted, this);
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxFullMeta.isNew, TaxFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxFullMeta.assignId, TaxFullMeta, this.assignId, this);
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  tempIDApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxFullMeta.tempID, TaxFullMeta, this.tempID, this);
  }
  tempIDIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIDIsSet && this.tempIDApplyFilter(filter)) return true;

    return false;
  }
  taxNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxFullMeta.taxName, TaxFullMeta, this.taxName, this);
  }
  taxNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxNameIsSet && this.taxNameApplyFilter(filter)) return true;

    return false;
  }
  taxCodeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxFullMeta.taxCode, TaxFullMeta, this.taxCode, this);
  }
  taxCodeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxCodeIsSet && this.taxCodeApplyFilter(filter)) return true;

    return false;
  }
  taxRateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(TaxFullMeta.taxRate, TaxFullMeta, this.taxRate, this);
  }
  taxRateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxRateIsSet && this.taxRateApplyFilter(filter)) return true;

    return false;
  }
  taxAmountFixedCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TaxFullMeta.taxAmountFixedCents,
      TaxFullMeta,
      this.taxAmountFixedCents,
      this,
    );
  }
  taxAmountFixedCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.taxAmountFixedCentsIsSet &&
      this.taxAmountFixedCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  taxMinValueCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TaxFullMeta.taxMinValueCents,
      TaxFullMeta,
      this.taxMinValueCents,
      this,
    );
  }
  taxMinValueCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxMinValueCentsIsSet && this.taxMinValueCentsApplyFilter(filter))
      return true;

    return false;
  }
  taxBeforeDiscountApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      TaxFullMeta.taxBeforeDiscount,
      TaxFullMeta,
      this.taxBeforeDiscount,
      this,
    );
  }
  taxBeforeDiscountIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.taxBeforeDiscountIsSet &&
      this.taxBeforeDiscountApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.tempIDIsSetDeep(filter)) return true;
    if (this.taxNameIsSetDeep(filter)) return true;
    if (this.taxCodeIsSetDeep(filter)) return true;
    if (this.taxRateIsSetDeep(filter)) return true;
    if (this.taxAmountFixedCentsIsSetDeep(filter)) return true;
    if (this.taxMinValueCentsIsSetDeep(filter)) return true;
    if (this.taxBeforeDiscountIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
